import React, { useRef, useState } from "react";
import ContentContainer from "../../../templates/content-container/contentContainer";
import { PAGE_IDS } from "../../../app/data/common/pageIds";
import "./index.scss";
import ContentContainerToolbar from "ui-components/molecules/content-container-toolbar/contentContainerToolbar";
import TerminalViewPickupSummary from "./TerminalViewPickupSummary/terminalViewPickup";
import CustomerViewPickupSummary from "./CustomerViewPickupSummary/customerViewPickup";
import DownloadButton from "ui-components/download-button/downloadButton";
import { useDownloadCSVCustomerView, useDownloadCSVTerminalView } from "hooks/usePickupSummary";

const PickupSummary: React.FC<{}> = (props) => {
  const tabs = ["Terminal View", "Customer View"];
  const [selectedTab, setSelectedTab] = useState("Terminal View");

  const terminalFilterRef = useRef<any>();
  const customerFilterRef = useRef<any>();

  const terminalCSV = useDownloadCSVTerminalView();
  const customerCSV = useDownloadCSVCustomerView();

  const handleDownload = async () => {
    const currentFilter =
      selectedTab === "Terminal View"
        ? terminalFilterRef.current
        : customerFilterRef.current;

    try {
      const blob =
        selectedTab === "Terminal View"
          ? await terminalCSV.mutateAsync(currentFilter)
          : await customerCSV.mutateAsync(currentFilter);

      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${selectedTab.replace(" ", "_")}_Pickup_Summary.csv`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("CSV download failed:", error);
    }
  };

  return (
    <ContentContainer
      className="xgs-list xgs-list--full-width"
      titleComponent={
        <ContentContainerToolbar
          pageId={PAGE_IDS.PICKUP_SUMMARY}
          title="Pickup Summary"
          mods={{ "full-width": true }}
        >
          <DownloadButton
            title="Download CSV"
            onClick={handleDownload}
            spinner={terminalCSV.isPending || customerCSV.isPending}
          />
        </ContentContainerToolbar>
      }
      mods={{ "full-width": true }}
    >
      <div className="tab-wrapper">
        <div className="tab-container">
          {tabs.map((tab, index) => (
            <div
              key={tab}
              onClick={() => setSelectedTab(tab)}
              className={`tab-item ${selectedTab === tab ? 'active' : ''} ${index === 0 ? 'first' : index === tabs.length - 1 ? 'last' : ''}`}>
              {tab}
            </div>
          ))}
        </div>
        <div>
          {selectedTab === "Terminal View" ? (
            <TerminalViewPickupSummary filterRefTerminal={terminalFilterRef} />
          ) : selectedTab === "Customer View" ? (
            <CustomerViewPickupSummary filterRefCustomer={customerFilterRef} />
          ) : null}
        </div>
      </div>
    </ContentContainer >
  );
};

export default PickupSummary;
